import React, { useState, useEffect } from "react";
import { db } from "./firebaseConfig";
import { doc, getDoc } from "firebase/firestore/lite";
import "aos/dist/aos.css";
import "./style.css";
import {
  // FaLaptopCode, 
  FaBuilding,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaBriefcase,
  FaCode,
  FaUsers
} from "react-icons/fa";
import { RiRemoteControlLine } from "react-icons/ri";

export const defaultExperiences = [
  {
    id: 1,
    title: "Java Fullstack Consultant",
    company: "LINK INGENIERIE",
    location: "Full-Remote",
    type: "Full-time",
    period: "03/2024 - 03/2026",
    duration: "2 year",
    description: "Leading development of enterprise-level software solutions using cutting-edge Java technologies and modern frontend frameworks. Collaborating with international teams to deliver scalable microservices architectures.",
    responsibilities: [
      "Develop comprehensive logistic management software using Java 21, Spring Boot, ReactJS and Angular",
      "Architect and implement insurance management platform with contract simulation and customer tracking",
      "Design and develop RESTful APIs using Open Feign, Spring Security, and best practices",
      "Implement authentication and authorization with Keycloak for enterprise security",
      "Build scalable microservices architecture with service discovery (Eureka) and monitoring",
      "Set up CI/CD pipelines using Jenkins and ensure code quality with SonarQube",
      "Containerize applications with Docker for consistent deployment environments",
      "Work with message brokers (RabbitMQ) for asynchronous communication",
      "Collaborate in Agile/Scrum environment using Jira and Confluence"
    ],
    technologies: ["Java 21", "Spring Boot", "ReactJS", "Angular", "Microservices", "Docker", "Jenkins", "Keycloak", "RabbitMQ", "Eureka", "SonarQube"],
    color: "bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300",
    isCurrent: true
  },
  {
    id: 2,
    title: "Web Developer",
    company: "AI AUTOMATION AGENCY",
    location: "Tangier, Morocco",
    type: "Hybrid",
    period: "07/2023 - 03/2024",
    duration: "8 months",
    description: "Developed innovative web applications and AI-powered solutions, focusing on chatbot development and LLM integration. Created intelligent automation systems for business processes.",
    responsibilities: [
      "Developed web applications using Java, Spring boot, ReactJS and Redux",
      // "Integrated HuggingFace models and GPT-4 for natural language processing",
      "Built PDF processing systems for document understanding and data extraction",
      "Deployed and managed applications on AWS infrastructure (EC2, S3)",
      "Implemented responsive designs and optimized application performance",
      "Created and deployed intelligent chatbots using LLMs and generative AI",
    ],
    technologies: ["ReactJS", "Redux", "Java", "Spring boot", "Python", "LLMs", "AWS EC2", "AWS S3"],
    color: "bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300",
    isCurrent: false
  },
  // {
  //   id: 3,
  //   title: "Full-Stack Java Web Developer",
  //   company: "FREELANCE",
  //   location: "Full-Remote",
  //   type: "Freelance",
  //   period: "12/2021 - 05/2023",
  //   duration: "~1.5 years",
  //   description: "Delivered custom web solutions for various clients, specializing in full-stack development with Java and modern frontend frameworks. Built secure, scalable applications from concept to deployment.",
  //   responsibilities: [
  //     "Developed robust backend systems using Java, Spring Boot, and Spring Security",
  //     "Created dynamic frontend applications with Angular, NgRx, ReactJS, and Redux",
  //     "Implemented secure authentication systems using JWT tokens",
  //     "Designed and developed RESTful APIs following industry best practices",
  //     "Managed database design and optimization for various projects",
  //     "Deployed applications to cloud platforms and managed production environments"
  //   ],
  //   technologies: ["Java", "Spring Boot", "Spring Security", "Angular", "ReactJS", "Redux", "JWT", "PostgreSQL", "MySQL"],
  //   color: "bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300",
  //   isCurrent: false
  // },
  {
    id: 4,
    title: "Java Web Developer",
    company: "SOFTONLINE TECHNOLOGIE",
    location: "Meknes, Morocco",
    type: "On-Site",
    period: "06/2020 - 12/2021",
    duration: "1.5 years",
    description: "Designed and developed scalable web applications using Java 8, JEE, Spring Boot, Spring Security, and JWT for the backend, and Angular, ReactJS, HTML, and CSS for the frontend.",
    responsibilities: [
      "Built complete platforms including an accommodation booking system with reservations and online payments, and an insurance claims management system. ",
      "Developed modules for data extraction and automation in public procurement systems. ",
    ],
    technologies: ["Java", "JEE", "Spring boot 2.x", "Spring Security", "Spring Data", "JWT", "REST API", "HTML", "CSSavaScript", "Angular 13", "ReactJS", "Redux", "SQL", "MySQL", "HTML5", "CSS3", "Bootstrap"],
    color: "bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300",
    isCurrent: false
  }
];

const Experience = () => {
  const [experiences, setExperiences] = useState(defaultExperiences);

  useEffect(() => {
    const fetchExperiences = async () => {
      try {
        const docRef = doc(db, 'portfolioData', 'experiences');
        const docSnap = await getDoc(docRef);

        if (docSnap.exists() && docSnap.data().items && docSnap.data().items.length > 0) {
          // If we have custom experiences in Firestore, use those
          setExperiences(docSnap.data().items);
        }
      } catch (error) {
        console.error("Error fetching experiences:", error);
      }
    };

    fetchExperiences();
  }, []);

  const getWorkTypeIcon = (type) => {
    switch (type.toLowerCase()) {
      case 'full-remote':
        return <RiRemoteControlLine />;
      case 'hybrid':
        return <FaUsers />;
      case 'on-site':
        return <FaBuilding />;
      case 'freelance':
        return <FaBriefcase />;
      default:
        return <FaBriefcase />;
    }
  };

  return (
    <section
      id="experience"
      className="bg-white dark:bg-gray-600 pt-16 pb-20 transition-colors duration-300"
    // data-aos="fade-up"
    >
      <div className="container mx-auto px-2 sm:px-4">
        <div className="experience-card bg-white dark:bg-gray-700 
          w-full md:w-[900px] lg:w-[1000px] mx-auto mt-10 pb-12 px-3 sm:px-4 md:px-6 lg:px-10 
          border-2 border-primaryColor dark:border-primaryColorDark shadow-lg 
          dark:shadow-2xl transition-colors rounded-lg">

          {/* Header Section */}
          <div className="text-center mb-12 pt-8">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 dark:text-primaryColorDark mb-4 transition-colors duration-300">
              <span className="border-b-4 border-primaryColor dark:border-primaryColorDark pb-2 transition-colors duration-300 inline-block">
                Professional Experience
              </span>
            </h1>
            <p className="text-gray-600 dark:text-gray-300 text-lg mt-4 transition-colors duration-300">
              Building innovative solutions and delivering value through technology
            </p>
          </div>

          {/* Experience Timeline */}
          <div className="relative">
            {/* Timeline Line */}
            <div className="absolute left-4 sm:left-6 md:left-12 top-0 bottom-0 w-1 bg-primaryColor dark:bg-primaryColorDark transition-colors duration-300"></div>

            {/* Experience Items */}
            <div className="space-y-12">
              {experiences.map((experience, index) => (
                <div
                  key={experience.id}
                  // data-aos="fade-right"
                  // data-aos-delay={index * 150}
                  className="relative pl-12 sm:pl-16 md:pl-24"
                >
                  {/* Timeline Dot */}
                  <div className="absolute left-0 sm:left-2 md:left-8 top-2 w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-primaryColor dark:bg-primaryColorDark border-4 border-white dark:border-gray-700 shadow-lg flex items-center justify-center transition-colors duration-300 z-10">
                    <div className="text-white text-base sm:text-lg">
                      {getWorkTypeIcon(experience.type)}
                    </div>
                  </div>

                  {/* Experience Card */}
                  <div className="bg-white dark:bg-gray-600 rounded-xl p-4 sm:p-6 md:p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200 dark:border-gray-500 hover:border-primaryColor dark:hover:border-primaryColorDark">
                    {/* Header */}
                    <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-4">
                      <div className="flex-1">
                        <div className="flex items-center gap-3 mb-2">
                          <div className={`p-2 rounded-lg bg-gray-100 dark:bg-gray-800 text-primaryColor dark:text-primaryColorDark`}>
                            {getWorkTypeIcon(experience.type)}
                          </div>
                          <div>
                            <h2 className="text-xl md:text-2xl font-bold text-gray-800 dark:text-white mb-1 transition-colors duration-300">
                              {experience.title}
                            </h2>
                            <div className="flex items-center gap-2 flex-wrap">
                              <span className="text-gray-700 dark:text-gray-300 font-semibold">
                                {experience.company}
                              </span>
                              {experience.isCurrent && (
                                <span className="px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 text-xs font-semibold rounded-full">
                                  Current
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Location & Type */}
                    <div className="mb-4 space-y-2">
                      <div className="flex items-center gap-4 flex-wrap">
                        <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400 text-sm">
                          <FaMapMarkerAlt className="text-primaryColor dark:text-primaryColorDark" />
                          <span>{experience.location}</span>
                        </div>
                        <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400 text-sm">
                          {getWorkTypeIcon(experience.type)}
                          <span className="text-primaryColor dark:text-primaryColorDark font-medium">{experience.type}</span>
                        </div>
                      </div>
                    </div>

                    {/* Period */}
                    <div className="flex items-center gap-2 text-primaryColor dark:text-primaryColorDark font-semibold mb-4">
                      <FaCalendarAlt />
                      <span>{experience.period}</span>
                      <span className="text-gray-500 dark:text-gray-400 text-sm font-normal">
                        ({experience.duration})
                      </span>
                    </div>

                    {/* Description */}
                    <p className="text-gray-600 dark:text-gray-300 leading-relaxed mb-4 transition-colors duration-300">
                      {experience.description}
                    </p>

                    {/* Key Responsibilities */}
                    <div className="mb-4">
                      <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3 flex items-center gap-2">
                        <FaBriefcase className="text-primaryColor dark:text-primaryColorDark" />
                        Key Responsibilities:
                      </h3>
                      <ul className="space-y-2">
                        {experience.responsibilities.map((responsibility, idx) => (
                          <li key={idx} className="flex items-start gap-2 text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
                            <span className="text-primaryColor dark:text-primaryColorDark mt-1.5">▸</span>
                            <span>{responsibility}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Technologies */}
                    <div className="mt-6 pt-4 border-t border-gray-200 dark:border-gray-500">
                      <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3 flex items-center gap-2">
                        <FaCode className="text-primaryColor dark:text-primaryColorDark" />
                        Technologies & Tools:
                      </h3>
                      <div className="flex flex-wrap gap-2">
                        {experience.technologies.map((tech, idx) => (
                          <span
                            key={idx}
                            className="px-3 py-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 text-xs font-medium rounded-md hover:bg-primaryColor/10 dark:hover:bg-primaryColorDark/20 hover:text-primaryColor dark:hover:text-primaryColorDark transition-colors duration-300"
                          >
                            {tech}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
